var map = {
	"./aviva/logos/main_transp.png": 7491,
	"./default/logos/main_transp.png": 8162,
	"./pilot/logos/main_transp.png": 1315,
	"./sompo/logos/main_transp.png": 3183,
	"./starr/logos/main_transp.png": 9147,
	"./tmg/logos/main_transp.png": 4701
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9593;